import { IJsonQueryDeveloper } from '../../../../../json_query';
import { ensureSingleTagExists } from '../../helpers';
import { ITagDefinition, TTag } from '../../index';

export const IGeoDeveloperTagType = 'geo-builder';

export interface IGeoDeveloperTag {
  type: 'geo-builder';
  value: number;
  text: string;
}

function isGeoDeveloperTag(tag: TTag): tag is IGeoDeveloperTag {
  return tag.type === IGeoDeveloperTagType;
}

export const geoDeveloperTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery, tagsData) => {
    const values =
      jsonQuery.geo &&
      (jsonQuery.geo.value.filter(geo => geo.type === 'builder') as IJsonQueryDeveloper[]).map(geo => geo.id);

    let nextTags = tags.filter(
      tag => tag.type !== IGeoDeveloperTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce((result, value) => {
        const tagData = tagsData.developers[value];

        return ensureSingleTagExists(
          result,
          (tag: TTag): tag is IGeoDeveloperTag => isGeoDeveloperTag(tag) && tag.value === value,
          previousTag => ({
            type: IGeoDeveloperTagType,
            value,
            text: tagData || 'Неизвестный застройщик',
          }),
        );
      }, nextTags);
    }

    return nextTags;
  },
};
